import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import PropsChecker from '@core-front/props-checker';
const CheckCore = (props) => {
    return (React.createElement(PropsChecker, { componentName: "Check", componentProps: props, defaultValueName: "defaultChecked", valueName: "checked", onChangeNames: "onChange", isComponentDisabled: props.disabled },
        React.createElement(AnalyticsTrigger, { trigger: { callback: 'onChange',
                id: ([checked]) => `Checkbox - ${checked ? 'Check' : 'Uncheck'} - ${props.id}`,
                elementType: 'checkbox',
                elementId: props.id,
                interactionType: ([checked]) => `${checked ? 'check' : 'uncheck'}` } },
            React.createElement(CheckCoreInner, Object.assign({}, props)))));
};
const CheckCoreInner = (props) => {
    const { components: { Icon, Skeleton, SkeletonItem }, input, checked, defaultChecked, onChange, disabled, value, id, labelText, children, extraContent, size, employee, employeeBackground, direction, indicatorAlign, hideLabel, className, fullWidthContent, } = props;
    const [innerChecked, setInnerChecked] = React.useState(defaultChecked || false);
    const isChecked = onChange && typeof checked !== 'undefined' ? checked : innerChecked;
    const handleChange = () => {
        const nextChecked = !isChecked;
        if (disabled) {
            return;
        }
        if (typeof checked === 'undefined') {
            setInnerChecked(nextChecked);
        }
        if (onChange) {
            onChange(nextChecked);
        }
    };
    const BEM = () => {
        const classArray = ['check'];
        if (size) {
            classArray.push(`check--${size}`);
        }
        if (employee) {
            classArray.push('check--employee');
        }
        if (employee && employeeBackground) {
            classArray.push('check--employee-background');
        }
        if (direction) {
            classArray.push(`check--${direction}`);
        }
        if (indicatorAlign) {
            classArray.push('check--indicator-' + indicatorAlign);
        }
        if (hideLabel) {
            classArray.push('check--hide-label');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getInputClass = () => {
        const classArray = ['check__input'];
        if (input && input.className) {
            classArray.push(input.className);
        }
        return classArray.join(' ');
    };
    const checkInnerBEM = () => {
        const classArray = ['check__inner'];
        if (fullWidthContent) {
            classArray.push('check__inner--full-width');
        }
        return classArray.join(' ');
    };
    if ('skeleton' in props) {
        const { skeleton } = props;
        const { lineCount = 1, lineHeight, lineWidth } = skeleton;
        return (React.createElement(Skeleton, { className: BEM(), label: skeleton.label },
            React.createElement("div", { className: checkInnerBEM() },
                React.createElement(SkeletonItem, { className: "check__indicator" }),
                React.createElement("div", { className: "check__content" }, [...Array(lineCount).keys()].map((_line, index) => (React.createElement(SkeletonItem, { key: index, height: lineHeight, width: lineWidth })))))));
    }
    return (React.createElement("div", { className: BEM() },
        React.createElement("input", Object.assign({}, input, { type: "checkbox", checked: isChecked, defaultChecked: undefined, disabled: disabled, value: value, onChange: handleChange, id: id, className: getInputClass(), "aria-invalid": props['aria-invalid'], "aria-describedby": props['aria-describedby'] })),
        React.createElement("label", { htmlFor: id, className: "check__label" }, labelText),
        React.createElement("div", { className: checkInnerBEM(), onClick: handleChange },
            React.createElement("span", { className: "check__indicator" },
                React.createElement(Icon, { modifiers: "#check", className: "check__icon" })),
            React.createElement("div", { className: "check__content", "aria-hidden": !children }, children || labelText)),
        extraContent && React.createElement("div", { className: "check__extra" }, extraContent)));
};
export default CheckCore;
